export default __webpack_public_path__ + "static/media/Ballroll_00152.695557e7.png";